<template>
  <div>
    <div class="houselist">
      <div class="houselist-t">
        <div class="houselist-t-1">{{lists.length>0 ? lists[0].community:''}}小区房源</div>
        <div class="houselist-t-2"></div>
      </div>
      <ul>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="true"
        >
          <li
            v-for="(item,index) in lists"
            :key="index"
            @click="$router.push('/zufang/view/'+item.id)"
          >
            <div class="img">
              <img :src="item.thumbnail" />
            </div>
            <div class="info">
              <h1>{{item.title}}</h1>
              <p
                class="txt2"
              >{{item.shi}}{{item.ting}}{{item.wei}} | {{item.area}}㎡ | {{item.community_cn}}</p>
              <p class="tag">
                <van-tag
                  color="#ecf3fe"
                  text-color="#6e86b1"
                  v-for="(v,i) in item.tese"
                  :key="i"
                >{{v}}</van-tag>
              </p>
              <p class="txt1">
                {{item.price ? item.price:'面议'}}
                <small>{{item.type=='zufang' ? '元/月' : '万元'}}</small>
              </p>
            </div>
          </li>
        </van-list>
      </ul>
    </div>
    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Footbar from "../commpents/footbar";
import { Swipe, SwipeItem, Row, Col, Tag, Icon, List } from "vant";

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [List.name]: List,
    Footbar
  },

  data() {
    return {
      getInitUrl: root + "zufang/list",
      current: 0,
      id: 0,
      model: {},
      lists: [],
      page: 1,
      total: 0,
      loading: false,
      finished: false
    };
  },

  mounted() {
    this.id = this.$route.params.id;
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: self.id, page: self.page },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var lists = reponseData.data.lists;
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
          self.Share();
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.loading = true;
        this.init();
        if (this.page >= this.total) {
          this.finished = true;
        }
      }, 500);
    },
    Share() {
      var title = "石柱房产网-买房.卖房.租房-找石柱生活网帮忙！";
      var description =
        "提供石柱县新楼盘、二手房、租房、商铺；房屋买卖，找石柱生活网房小柒帮忙！";
      var avatar = "http://fc.45win.com/house/web/images/logo.png";
      var url = "http://adn.45win.com/html/#/";
      this.setShare(title, description, url, avatar);
    }
  }
};
</script>

<style scoped>
</style>>



